export default __webpack_public_path__ + "static/media/INXC.65d85ec9.svg";